var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { "no-margin": "" } },
                [
                  _c(
                    "w-button",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.goToScripts()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                    1
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Script uploaden",
                              expression: "'Script uploaden'",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              _vm.uploadModalOpen = true
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "upload" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Script downloaden",
                              expression: "'Script downloaden'",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.downloadScript()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "download" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Opslaan",
                              expression: "'Opslaan'",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "save" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Eigenschappen bewerken",
                              expression: "'Eigenschappen bewerken'",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editProperties()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "wrench" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "", center: "" } },
        [
          _c(
            "transition",
            { staticClass: "fast-fade", attrs: { mode: "out-in" } },
            [
              !_vm.ready
                ? _c(
                    "w-col",
                    { attrs: { center: "" } },
                    [_c("w-progress-circular")],
                    1
                  )
                : _c(
                    "w-col",
                    { style: { height: "100%" }, attrs: { grow: "" } },
                    [
                      _c(
                        "w-card",
                        {
                          staticClass: "grow",
                          style: { maxHeight: "100%" },
                          attrs: { tag: "w-card" },
                        },
                        [
                          _c(
                            "w-card-title",
                            [
                              _vm._v(" " + _vm._s(_vm.script.Name) + " "),
                              _vm.info
                                ? _c(
                                    "w-link",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.info,
                                          expression: "info",
                                        },
                                      ],
                                      staticClass: "ml",
                                    },
                                    [
                                      _c("w-fa", {
                                        attrs: { icon: "info-circle" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "w-scroll-view",
                            {
                              staticClass: "grow no-margin",
                              attrs: { tag: "w-col" },
                            },
                            [
                              _c("codemirror", {
                                ref: "codeEditor",
                                staticClass: "grow",
                                attrs: { options: _vm.cmOptions },
                                model: {
                                  value: _vm.script.Content,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.script, "Content", $$v)
                                  },
                                  expression: "script.Content",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.propertiesModal,
            callback: function ($$v) {
              _vm.propertiesModal = $$v
            },
            expression: "propertiesModal",
          },
        },
        [
          _c("app-dossier-script-edit-properties", {
            attrs: { "dossier-id": _vm.dossier.id, script: _vm.script },
            on: {
              close: function ($event) {
                _vm.propertiesModal = false
              },
            },
          }),
        ],
        1
      ),
      _vm.uploadModalOpen
        ? _c("app-dossier-script-edit-upload", {
            on: {
              close: function ($event) {
                _vm.uploadModalOpen = false
              },
              input: function ($event) {
                return _vm.onFileUploadResult($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }